 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Admin~EditPlant~EditProfile~Home~Howto~HowtoMap~Login~Main~MainAdminPage~MainHowto~MainStatistic~Not~d881e0b5":"Admin~EditPlant~EditProfile~Home~Howto~HowtoMap~Login~Main~MainAdminPage~MainHowto~MainStatistic~Not~d881e0b5","Admin~EditPlant~EditProfile~Home~Login~Main~MainAdminPage~NoteSeeding~Pruksa~Register~ReportNursery~Static":"Admin~EditPlant~EditProfile~Home~Login~Main~MainAdminPage~NoteSeeding~Pruksa~Register~ReportNursery~Static","Admin~EditPlant~EditProfile~Login~NoteSeeding~PlantKnowledge~Register~ReportNursery~Static":"Admin~EditPlant~EditProfile~Login~NoteSeeding~PlantKnowledge~Register~ReportNursery~Static","Admin":"Admin","EditPlant~EditProfile~Main~MainAdminPage~NoteSeeding~Register~ReportNursery":"EditPlant~EditProfile~Main~MainAdminPage~NoteSeeding~Register~ReportNursery","EditPlant":"EditPlant","EditProfile":"EditProfile","NoteSeeding":"NoteSeeding","Register":"Register","ReportNursery":"ReportNursery","Login":"Login","Static":"Static","Main~MainAdminPage":"Main~MainAdminPage","Main":"Main","MainAdminPage":"MainAdminPage","Home~Pruksa":"Home~Pruksa","Home":"Home","Pruksa":"Pruksa","PlantKnowledge":"PlantKnowledge","Howto":"Howto","HowtoMap":"HowtoMap","MainHowto":"MainHowto","MainStatistic":"MainStatistic","PlantTop":"PlantTop","Report":"Report"}[chunkId]||chunkId) + "." + {"Admin~EditPlant~EditProfile~Home~Howto~HowtoMap~Login~Main~MainAdminPage~MainHowto~MainStatistic~Not~d881e0b5":"b3a896e3","Admin~EditPlant~EditProfile~Home~Login~Main~MainAdminPage~NoteSeeding~Pruksa~Register~ReportNursery~Static":"26964376","Admin~EditPlant~EditProfile~Login~NoteSeeding~PlantKnowledge~Register~ReportNursery~Static":"5513a864","Admin":"11ad6898","EditPlant~EditProfile~Main~MainAdminPage~NoteSeeding~Register~ReportNursery":"0afc8625","EditPlant":"9922d074","EditProfile":"f8565262","NoteSeeding":"034a455d","Register":"03720ac0","ReportNursery":"aed17bff","Login":"3ebb648d","Static":"c9ef62d8","Main~MainAdminPage":"604240c6","Main":"07d34740","MainAdminPage":"ad9ac134","Home~Pruksa":"fd4ba708","Home":"3d95a555","Pruksa":"4caff7b9","PlantKnowledge":"011f9075","Howto":"40470a38","HowtoMap":"a4ed3dcd","MainHowto":"ade8b8bf","MainStatistic":"e9e24f1c","PlantTop":"23688b40","Report":"66e586d0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Admin~EditPlant~EditProfile~Home~Howto~HowtoMap~Login~Main~MainAdminPage~MainHowto~MainStatistic~Not~d881e0b5":1,"Admin~EditPlant~EditProfile~Home~Login~Main~MainAdminPage~NoteSeeding~Pruksa~Register~ReportNursery~Static":1,"Admin~EditPlant~EditProfile~Login~NoteSeeding~PlantKnowledge~Register~ReportNursery~Static":1,"Admin":1,"EditPlant~EditProfile~Main~MainAdminPage~NoteSeeding~Register~ReportNursery":1,"EditPlant":1,"EditProfile":1,"NoteSeeding":1,"Register":1,"ReportNursery":1,"Login":1,"Static":1,"Main~MainAdminPage":1,"Main":1,"MainAdminPage":1,"Home~Pruksa":1,"Home":1,"Pruksa":1,"PlantKnowledge":1,"Howto":1,"HowtoMap":1,"MainHowto":1,"MainStatistic":1,"PlantTop":1,"Report":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Admin~EditPlant~EditProfile~Home~Howto~HowtoMap~Login~Main~MainAdminPage~MainHowto~MainStatistic~Not~d881e0b5":"Admin~EditPlant~EditProfile~Home~Howto~HowtoMap~Login~Main~MainAdminPage~MainHowto~MainStatistic~Not~d881e0b5","Admin~EditPlant~EditProfile~Home~Login~Main~MainAdminPage~NoteSeeding~Pruksa~Register~ReportNursery~Static":"Admin~EditPlant~EditProfile~Home~Login~Main~MainAdminPage~NoteSeeding~Pruksa~Register~ReportNursery~Static","Admin~EditPlant~EditProfile~Login~NoteSeeding~PlantKnowledge~Register~ReportNursery~Static":"Admin~EditPlant~EditProfile~Login~NoteSeeding~PlantKnowledge~Register~ReportNursery~Static","Admin":"Admin","EditPlant~EditProfile~Main~MainAdminPage~NoteSeeding~Register~ReportNursery":"EditPlant~EditProfile~Main~MainAdminPage~NoteSeeding~Register~ReportNursery","EditPlant":"EditPlant","EditProfile":"EditProfile","NoteSeeding":"NoteSeeding","Register":"Register","ReportNursery":"ReportNursery","Login":"Login","Static":"Static","Main~MainAdminPage":"Main~MainAdminPage","Main":"Main","MainAdminPage":"MainAdminPage","Home~Pruksa":"Home~Pruksa","Home":"Home","Pruksa":"Pruksa","PlantKnowledge":"PlantKnowledge","Howto":"Howto","HowtoMap":"HowtoMap","MainHowto":"MainHowto","MainStatistic":"MainStatistic","PlantTop":"PlantTop","Report":"Report"}[chunkId]||chunkId) + "." + {"Admin~EditPlant~EditProfile~Home~Howto~HowtoMap~Login~Main~MainAdminPage~MainHowto~MainStatistic~Not~d881e0b5":"daa8cfe1","Admin~EditPlant~EditProfile~Home~Login~Main~MainAdminPage~NoteSeeding~Pruksa~Register~ReportNursery~Static":"1ed29b95","Admin~EditPlant~EditProfile~Login~NoteSeeding~PlantKnowledge~Register~ReportNursery~Static":"23bc5512","Admin":"2cac227b","EditPlant~EditProfile~Main~MainAdminPage~NoteSeeding~Register~ReportNursery":"d5065d7a","EditPlant":"43dad2c1","EditProfile":"642aa14e","NoteSeeding":"46f6d420","Register":"78db4369","ReportNursery":"c02cd59a","Login":"dd387da2","Static":"f217c966","Main~MainAdminPage":"235d6350","Main":"746324c3","MainAdminPage":"e262fd95","Home~Pruksa":"ceebf590","Home":"2ad34761","Pruksa":"35cb5235","PlantKnowledge":"32a36563","Howto":"c0dae09f","HowtoMap":"893f2b15","MainHowto":"f3efbc35","MainStatistic":"d031b1ec","PlantTop":"1a8cfecf","Report":"d25701d7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
